import { gql } from "@apollo/client";

export const VALIDAR_PRE_LIQUIDACION = gql`
    query validarPreLiquidacion($idLiquidacionProfesional: Int!) {
        validarPreLiquidacion(idLiquidacionProfesional: $idLiquidacionProfesional) {
            success
            error
            valorEsperado{
                idLiquidacionProfesional 
                idProfesional 
                nombre 
                apellido 
            }
        }
    }
`;